import { SET, REMOVE } from '../constants/attribute-operations';
import { OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE } from '../constants/display-options';
import {
  BACKGROUND_IMAGE_ATTRIBUTE,
  BACKGROUND_PLACEHOLDER_ATTRIBUTE,
} from '../constants/block-background-attributes';
import isBackgroundOptionChanged from '../verifiers/is-background-option-changed';

const getBackgroundAttributeOperations = ({ backgroundOption, displayOptions = [] }) => {
  if (!backgroundOption || !isBackgroundOptionChanged(backgroundOption)) {
    return [];
  }

  const shouldSkipDesignAutomation = displayOptions.some(
    ({ attribute, touched }) =>
      [OVERLAY_ATTRIBUTE, OVERLAY_OPACITY_ATTRIBUTE].includes(attribute) && touched
  );

  const { elementId, values } = backgroundOption;

  const attributesOperations = Object.entries(values).map(([attribute, value]) => ({
    value,
    name: attribute,
    operation: SET,
    elementId,
    ...(attribute === BACKGROUND_IMAGE_ATTRIBUTE &&
      shouldSkipDesignAutomation && {
        options: {
          skipDesignAutomation: true,
        },
      }),
  }));

  attributesOperations.push({
    operation: REMOVE,
    name: BACKGROUND_PLACEHOLDER_ATTRIBUTE,
    elementId,
  });

  return attributesOperations;
};

export default getBackgroundAttributeOperations;
